import { Entries } from "../Entries/Entries";
import { ComponentsOrGroups } from "@/types/types.ts";
import { StandardProps } from "@/components/componentMap.ts";
import { noticeError } from "@/utils/newrelic/requests";

type GroupsProps = {
  className?: string;
  groups: ComponentsOrGroups;
  sizes: string;
} & StandardProps;

export const Groups = ({
  className,
  groups,
  sizes,
  ...standardProps
}: GroupsProps) => {
  if (!groups || groups.length === 0) {
    return null;
  }

  return groups.map((componentGroup, index) => {
    if (!Array.isArray(componentGroup)) {
      noticeError(
        `Invalid group usage. Grouped slots can only render component groups.`,
      );
      return null;
    }

    if (componentGroup.length === 0) {
      return null;
    }

    return (
      <div
        className={className}
        data-testid="group-slot"
        key={`GroupSlot-${index}`}
      >
        <Entries components={componentGroup} sizes={sizes} {...standardProps} />
      </div>
    );
  });
};
